import _ from 'underscore';
import GalleryModal from './modules/gallery-modal';
import ToggleContentToModal from './modules/gallery/toggle-content-to-modal';
import {
  dispatchSiteEvent,
  siteEventNames,
} from './events/site-events';
import {
  getTruncatedWidenUrl,
  localStorageSwatchEventHandlers,
  getSwatchProductUrlParams,
} from './modules/swatchbook-utils';
import {
  getItemsFromAccount,
  removeItemFromAccount,
  saveItemToAccount,
} from './modules/consumer-account/storage-actions';

_.templateSettings = {
  interpolate: /\{\{(.+?)\}\}/g,
};

const imageTemplate =
  `<div class="modal fade show" id="modal-{{ newId }}" role="dialog" aria-labelledby="modal-label-{{ newId }}">
      <div class="modal-dialog rounded-0" role="document">
        <div class="modal-content rounded-0">
            <div class="row-eq-height">
                <div class="col-12 col-sm-6">
                    <div class="modal-image">
                        <img class="w-100" src="{{ imageSrc }}" alt="{{ imageAlt }}">
                    </div>
                </div>
                <div class="col-12 col-sm-6 modal-body">
                    <button type="button" class="btn-close position-absolute top-0 end-0 mt-2 me-2 bg-white" aria-label="Close Modal" type="button" data-bs-dismiss="modal"></button>
                    <span class="sr-only" id="modal-label-{{ newId }}">{{ modalLabel }}</span>
                    <h4 class="modal-title">{{ productLineName }}</h4>
                    <div class="image-caption">
                        <p>{{ productDescription }}</p>
                    </div>
                    <div class="image-story">
                        <p class="mb-0">{{ imageStory }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>`;

const visualizerDetailsTemplate =
  `<div>
    <a href="/visualization/?minimal=&amp;Brand=Bali&amp;Model={{ visualizerModelId }}&amp;ProgramFamilyName={{ visualizerProgamFamilyName }}&amp;OE.CLR={{ colorNumber }}" class="visualizer-link" onclick="event.stopPropagation();">View in Visualizer</a>
    <span class="show-detail-btn">
      <button class="icon icon--zoom btn btn-transparent p-0"></button>
    </span>
  </div>`;

const addSwatchModal = () => {
  GalleryModal.init({
    imageTemplate,
    galleryModalSelector: '.swatch-link',
  });
  const filters = document.querySelectorAll('.filter-event');
  [].map.call(filters, filter => filter.addEventListener('click', () => setTimeout(() => {
    GalleryModal.init({
      imageTemplate,
      galleryModalSelector: '.swatch-link',
    });
  }, 500)));
};

const getItemBySwatchId = (data, id) => (
  data.find(item => id === `swatch-${item['style-id']}-${item['swatch-category-id']}-${item['swatch-id']}`)
);

const accountStorageSwatchEventHandler = (item, swatches) => {
  const btn = item.querySelector('.swatchbutton');
  if (btn === null) { // In the event that "swatch is not available, there is no button"
    return;
  }
  const label = item.querySelector('.swatchbutton--label');
  const id = item.getAttribute('id');
  // Toggle button to remove state if in swatchbook
  const swatchAsset = getItemBySwatchId(swatches, id);
  if (swatchAsset) {
    btn.classList.add('is-active');
    // Add data-asset-id attribute to button
    btn.setAttribute('data-asset-id', swatchAsset['digital-swatch-id']);
    label.innerHTML = 'Remove Swatch';
  } else {
    btn.classList.remove('is-active');
    label.innerHTML = 'Add Swatch';
  }
  // Add/remove swatch event handlers
  btn.addEventListener('click', (event) => {
    event.stopPropagation();
    btn.classList.add('btn--disabled');
    if (btn.classList.toString().indexOf('is-active') !== -1) {
      // Remove
      const assetId = btn.getAttribute('data-asset-id');
      removeItemFromAccount('swatch', assetId, () => {
        btn.classList.remove('is-active');
        label.innerHTML = 'Add Swatch';
        // Update cart
        dispatchSiteEvent(siteEventNames.REMOVE_SWATCH);
      });
    } else {
      // Add
      saveItemToAccount(
        'swatch',
        {
          productLineCode: btn.getAttribute('data-productLineCode'),
          colorNumber: btn.getAttribute('data-colorNumber'),
          swatchId: btn.getAttribute('data-swatchId'),
          widenUrl: getTruncatedWidenUrl(btn.getAttribute('data-imageUrl')),
        },
        (data) => {
          btn.classList.remove('btn--disabled');
          if (data.success) {
            btn.classList.add('is-active');
            label.innerHTML = 'Remove Swatch';
            // Set asset id
            btn.setAttribute('data-asset-id', data['asset-id']);
            // Update cart
            dispatchSiteEvent(siteEventNames.ADD_SWATCH);
          }
        },
      );
    }
  });
};

const addSwatchVisualizationNav = (data) => {
  const {
    visualizerModelId,
    visualizerProgamFamilyName,
  } = data;
  // Go through each swatch present (all are same product) in DOM and append visualization links, if exist
  if (visualizerModelId === null || visualizerProgamFamilyName === null) {
    return;
  }
  const visualizerDetailsTemplateVals = _.template(visualizerDetailsTemplate);
  // const imageVisualizationTemplateVals = _.template(imageVisualizationTemplate);
  const detailDivs = document.querySelectorAll('.swatch');
  for (let i = 0; i < detailDivs.length; i++) { /* eslint-disable-line no-plusplus */
    // Get color number, append to data object
    const btn = detailDivs[i].querySelector('.swatchbutton');
    if (btn !== null) { // Swatch not available, no button...
      data.colorNumber = btn.getAttribute('data-colornumber');
      // Wipe existing content
      const detail = detailDivs[i].querySelector('.swatchcard--viewdetail');
      detail.innerHTML = '';
      // Create visualization detail nav
      const div = document.createElement('div');
      const compiled = visualizerDetailsTemplateVals(data);
      div.innerHTML = compiled;
      detail.appendChild(div.firstChild);
    }
  }
};

const addFiltersModal = () => {
  const filterToggle = new ToggleContentToModal({ /* eslint-disable-line no-unused-vars */
    callbacks: {
      onOpen: () => {
        //
      },
      onClose: () => {
        //
      },
    },
    modalId: 'filter-and-sort-modal',
    toggleSelector: '.btn-filter-sort',
    toggleContent: [
      {
        content: '.product-filter-group',
        modalSelector: '#filter-and-sort-modal .product-filter-wrapper',
        defaultSelector: '#swatches-container .two-columns--left',
      },
    ],
  });
};

const getSwatchVisualizationParams = () => {
  const { products, id } = window;
  const product = products.find(item => item.Id === id);
  getSwatchProductUrlParams(product.Name, (responseData) => {
    addSwatchVisualizationNav(responseData);
  });
};

const addEventListeners = () => {
  if (document.querySelector('.swatch-link')) {
    // Init modals
    addSwatchModal();
    addFiltersModal();
    // Add visualization parameters
    if (window.isVisualizerActive && window.products) {
      getSwatchVisualizationParams();
    }
    // Add to account if logged-in, otherwise add to local storage
    if (window.isAuthenticated) {
      // Get swatches, then add save to account handling
      getItemsFromAccount('swatch', (data) => {
        [].map.call(document.querySelectorAll('.swatch'), (item) => {
          accountStorageSwatchEventHandler(item, data.swatches);
        });
      });
    } else {
      // Add save to favorites event handling
      [].map.call(document.querySelectorAll('.swatch'), (item) => {
        localStorageSwatchEventHandlers(item);
      });
    }
  }
};

// Run on load
addEventListeners();
// Add to window
window.addSwatchOrderingEventListeners = addEventListeners;

export {
  addEventListeners,
  addSwatchModal,
};
